module.exports = __webpack_public_path__ + "static/media/UPM.acda0163.png";